
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NumberSection } from '@unreserved-frontend-v2/ui/content-section/number-section/number-section';
import { SimplifiedBaseSectionProps } from '../layouts';
export const Step1Component = ({ stepNumber = '', subTitle = '' }: SimplifiedBaseSectionProps) => {
    const config = {
        content: 'inner-pages:buying-simplified.step-1-content',
        components: [
            <p key="paragraph" className="pb-6 text-lg leading-[34px] lg:pb-[34px]"/>,
            <span key="bold-text" className="text-lg font-bold"/>,
        ],
        image: '/static/images/down-payment.jpg',
        containerClassName: 'mt-11 lg:mt-6 lg:mt-[73px]',
        contentClassName: 'relative z-[1] pt-6 lg:pt-[42px] lg:col-span-7 lg:pt-0 lg:pr-[30px]',
        stepNumberClassName: 'left-[-10px] top-[-35px] lg:left-[-220px] lg:top-[-90px]',
        imageContainerClassName: 'col-span-5 col-start-8 hidden lg:block',
        imageClassName: 'right-[-55px] top-[30px] h-[500px]',
        mobileImageContainerClassName: 'col-span-12 row-start-1 -mr-5 block overflow-hidden lg:hidden',
        mobileImageSecondaryContainerClassName: '-mr-[7%] pr-5'
    };
    return <NumberSection {...config} stepNumber={stepNumber} subTitle={subTitle}/>;
};
export default Step1Component;

    async function __Next_Translate__getStaticProps__1955d79d562__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//learn-more/buying-simplified/step-1-component',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1955d79d562__ as getStaticProps }
  